require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-53-how-do-i-delete-comments-from-my-project.json") })
        }
      }, "path---article-53-how-do-i-delete-comments-from-my-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-53-how-do-i-delete-comments-from-my-project!./.cache/json/article-53-how-do-i-delete-comments-from-my-project.json
// module id = 556
// module chunks = 231608221292675